import { ErrorBoundary, NonBlockEntrypoint } from "@softr-io/blocks-sdk/react";
import { lazy, Suspense, useMemo } from "react";
import { BlockDefinition, LegacyBlockTheme } from "@softr-io/blocks-sdk";
import { useAppConstants } from "./AppConstantsContext";
import { usePageContext } from "./PageContext";
import { retry } from "./retry";

export function DialogsAndModals({
    theme,
    definitions,
}: {
    theme: LegacyBlockTheme;
    definitions: readonly BlockDefinition[];
}) {
    const { baseUrl } = useAppConstants();
    const baseUrlWithoutBlocks = baseUrl.replace(/\/blocks(\/)?$/, "");

    const GlobalSearchPath = `${baseUrlWithoutBlocks}/assets/GlobalSearch.mjs`;

    const GlobalSearch = useMemo(
        () =>
            lazy(() =>
                retry(
                    () =>
                        import(
                            /* webpackIgnore: true */
                            GlobalSearchPath
                        ) as Promise<{ default: NonBlockEntrypoint }>,
                ),
            ),
        [GlobalSearchPath],
    );
    const CommentsDialogPath = `${baseUrlWithoutBlocks}/assets/CommentsDialog.mjs`;

    const CommentsDialog = useMemo(
        () =>
            lazy(() =>
                retry(
                    () =>
                        import(
                            /* webpackIgnore: true */
                            CommentsDialogPath
                        ) as Promise<{ default: NonBlockEntrypoint }>,
                ),
            ),
        [CommentsDialogPath],
    );
    const OpenPageDialogPath = `${baseUrlWithoutBlocks}/assets/OpenPageDialog.mjs`;

    const OpenPageDialog = useMemo(
        () =>
            lazy(() =>
                retry(
                    () =>
                        import(
                            /* webpackIgnore: true */
                            OpenPageDialogPath
                        ) as Promise<{ default: NonBlockEntrypoint }>,
                ),
            ),
        [OpenPageDialogPath],
    );

    const AgentDialogPath = `${baseUrlWithoutBlocks}/assets/AgentDialog.mjs`;

    const AgentDialog = useMemo(
        () =>
            lazy(() =>
                retry(
                    () =>
                        import(
                            /* webpackIgnore: true */
                            AgentDialogPath
                        ) as Promise<{ default: NonBlockEntrypoint }>,
                ),
            ),
        [AgentDialogPath],
    );

    const { appId, spaMode } = useAppConstants();
    const { pageId, currentRecord } = usePageContext();
    return [GlobalSearch, CommentsDialog, OpenPageDialog, AgentDialog].map((Component, index) => (
        <Suspense fallback={null} key={index}>
            <ErrorBoundary>
                <Component
                    theme={theme}
                    appId={appId}
                    pageId={pageId}
                    spaMode={spaMode}
                    baseUrlForAssetsDir={baseUrlWithoutBlocks}
                    blocks={definitions}
                    currentRecord={currentRecord}
                />
            </ErrorBoundary>
        </Suspense>
    ));
}
